import { Easing, Tween, update } from "@tweenjs/tween.js";
import type { LatLngLiteral, Map } from "../types";

let isMoving = false;
export const moveMapToPosition = (map: Map, position: LatLngLiteral, zoom: number, duration: number = 750, onComplete?: () => void): void => {
  if (isMoving) return;
  isMoving = true;

  const centerOptions = {
    center: {
      lat: map.getCenter()?.lat() || 0,
      lng: map.getCenter()?.lng() || 0,
    },
  };

  const mapZoom = map.getZoom();
  const zoomOptions = {
    zoom: mapZoom,
  };

  new Tween(centerOptions)
    .to(
      {
        center: position,
      },
      duration,
    )
    .easing(Easing.Quadratic.Out)
    .onUpdate(() => {
      map.moveCamera(centerOptions);
    })
    .start();

  new Tween(zoomOptions)
    .to(
      {
        zoom: zoom === undefined ? mapZoom : zoom,
      },
      duration,
    )
    .easing(Easing.Quadratic.In)
    .onUpdate(() => {
      map.moveCamera(zoomOptions);
    })
    .start()
    .onComplete(() => {
      isMoving = false;
      onComplete?.();
    });

  const animate = (time: number): void => {
    update(time);
    if (isMoving) requestAnimationFrame(animate);
  };

  requestAnimationFrame(animate);
};
